import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import * as css from '../styles'

export const UploadingPhase = () => {
  return (
    <css.DialogContentStyled>
      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
        Uploading Selected File ...
      </Typography>
      <css.ProgressWrapper>
        <CircularProgress size={70} thickness={4} />
      </css.ProgressWrapper>
    </css.DialogContentStyled>
  )
}
